export const organization = {
  '@context': 'http://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': 'https://motos.coches.net/#website',
      url: 'https://motos.coches.net/',
      name: 'motos.net',
      description: 'Portal de motos nuevas y motos de ocasión',
      inLanguage: 'es',
      publisher: {
        '@id': 'https://motos.coches.net/#organization'
      }
    },
    {
      '@context': 'http://schema.org',
      '@type': 'Organization',
      '@id': 'https://motos.coches.net/#organization',
      url: 'https://motos.coches.net/',
      name: 'motos.net',
      legalName: 'Adevinta Motor S.L.U.',
      foundingDate: '1999',
      description: 'Portal líder de motor en España para comprar y vender motos nuevas y de ocasión',
      taxID: 'B-70677158',
      logo: {
        '@type': 'ImageObject',
        '@id': 'https://motos.coches.net/#logo',
        url: 'https://s.ccdn.es/images/motos/icons/logo-square-rounded-512x512.png',
        height: 512,
        width: 512,
        caption: 'motos.net'
      },
      image: {
        '@id': 'https://motos.coches.net/#logo'
      },
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'C/Hernani, 59, 1a planta',
        addressLocality: 'Madrid',
        postalCode: '28020',
        addressCountry: 'ES'
      },
      sameAs: [
        'https://www.youtube.com/user/canalmotosnet',
        'https://www.facebook.com/Motos.net',
        'https://x.com/motosnet',
        'https://www.instagram.com/motosnet/',
        'https://www.tiktok.com/@motos.net'
      ],
      parentOrganization: {
        '@type': 'Organization',
        '@id': 'https://www.adevinta.com/#organization',
        name: 'Adevinta',
        url: 'https://www.adevinta.com/',
        logo: {
          '@type': 'ImageObject',
          '@id': 'https://www.adevinta.com/#logo',
          inLanguage: 'en-US',
          url: 'https://s.ccdn.es/images/common/logos/adevinta-logo.svg',
          contentUrl: 'https://s.ccdn.es/images/common/logos/adevinta-logo.svg',
          width: 430,
          height: 96,
          caption: 'Adevinta'
        },
        image: {
          '@id': 'https://www.adevinta.com/#logo'
        }
      }
    }
  ]
}
